<template>
  <div class="tw-relative">
    <a :href="helpCenterUrl" target="_blank">
      <SvgIcon
        name="question-stroke"
        class="tw-pointer-events-none help-menu-icon"
      />
    </a>
  </div>
</template>

<script>
import documentationUrls from '@/documentations/documentation-urls'

export default {
  name: 'HelpMenu',

  computed: {
    helpCenterUrl() {
      return documentationUrls.helpCenterUrl
    },
  },
}
</script>
<style scoped>
.help-menu-icon {
  height: 20px;
  width: 20px;
}
</style>
